import {RootState} from '../../../store/store';
import {useSelector} from 'react-redux';

function selector(state: RootState) {
    return state.adminUser;
}

export function useAdminUser() {
  return useSelector<RootState, ReturnType<typeof selector>>(selector);
}
